import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e2d5104"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid p-component p-formgrid p-grid p-input-filled p-p-2" }
const _hoisted_2 = { class: "p-field p-col-12" }
const _hoisted_3 = { for: "name" }
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = { class: "p-field p-col-12" }
const _hoisted_6 = { for: "file" }
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = { class: "p-field p-col-12" }
const _hoisted_9 = ["for"]
const _hoisted_10 = { class: "p-field p-col-12" }
const _hoisted_11 = { for: "interval" }
const _hoisted_12 = {
  key: 0,
  class: "p-error"
}
const _hoisted_13 = {
  key: 1,
  class: "p-error"
}
const _hoisted_14 = { class: "p-field p-col-3" }
const _hoisted_15 = { for: "active" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('Squeeze.System.Name')) + " *", 1),
      _createVNode(_component_InputText, {
        id: "name",
        modelValue: _ctx.v$.name.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.name.$model) = $event)),
        class: _normalizeClass({'p-invalid':_ctx.v$.name.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update,
        required: "true",
        autofocus: ""
      }, null, 8, ["modelValue", "class", "onChange"]),
      ((_ctx.v$.name.$invalid && _ctx.showErrorMessage))
        ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.System.Name')})), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('Squeeze.System.Script')) + " *", 1),
      _createVNode(_component_Dropdown, {
        id: "file",
        modelValue: _ctx.value.scriptId,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.scriptId) = $event)),
        options: _ctx.allScripts,
        onChange: _ctx.update,
        optionValue: "id",
        optionLabel: "name",
        filter: true,
        autoFilterFocus: true,
        onShow: _ctx.showDropdownOverlay
      }, null, 8, ["modelValue", "options", "onChange", "onShow"]),
      (_ctx.v$.scriptId.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.System.Script')})), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.intervals, (interval) => {
        return (_openBlock(), _createElementBlock("div", {
          key: interval.key,
          class: "p-field-radiobutton"
        }, [
          _createVNode(_component_RadioButton, {
            id: interval.key,
            name: "interval",
            value: interval,
            modelValue: _ctx.selectedInterval,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedInterval) = $event)),
            onChange: ($event: any) => (_ctx.onChangeRadioButton(interval))
          }, null, 8, ["id", "value", "modelValue", "onChange"]),
          _createElementVNode("label", {
            for: interval.key
          }, _toDisplayString(interval.name), 9, _hoisted_9),
          (interval.key === 'custom')
            ? (_openBlock(), _createBlock(_component_Badge, {
                key: 0,
                class: "mdi mdi-comment-question-outline",
                onClick: _ctx.goToCronGuru
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('Squeeze.System.CronExpression')) + " *", 1),
      _createVNode(_component_InputText, {
        id: "interval",
        modelValue: _ctx.v$.cronExpression.$model,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.cronExpression.$model) = $event)),
        class: _normalizeClass({'p-invalid':_ctx.v$.cronExpression.$invalid && _ctx.showErrorMessage && _ctx.showCustomInput}),
        onChange: _ctx.update,
        required: "true",
        disabled: !_ctx.showCustomInput
      }, null, 8, ["modelValue", "class", "onChange", "disabled"]),
      ((_ctx.v$.cronExpression.$invalid && _ctx.showErrorMessage && _ctx.showCustomInput && !_ctx.v$.cronExpression.cronExpressionValidation.$invalid))
        ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.System.CronExpression')})), 1))
        : _createCommentVNode("", true),
      (_ctx.v$.cronExpression.cronExpressionValidation.$invalid && _ctx.showErrorMessage && _ctx.showCustomInput)
        ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(_ctx.$t('Forms.Val.CronExpression')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('Squeeze.System.Active')), 1),
      _hoisted_16,
      _createVNode(_component_Checkbox, {
        id: "active",
        modelValue: _ctx.value.active,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.value.active) = $event)),
        binary: true
      }, null, 8, ["modelValue"])
    ])
  ]))
}